// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1z5jh","title":"AfterBackImages_title__3JtMz","images":"AfterBackImages_images__3WCBG"};